import { Color, Flex, Spacing, Text, Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { MAX_VAT_EXEMPTION_MENTION_LENGTH } from '../../../../../../constants/maxVatExemptionMentionLength'
import { useVatExemptionMentionModalForm } from '../../../../context/vatExemptionMentionModalFormContext'

const TEXT_AREA_ROWS_COUNT = 2

export const VatExemptionMentionField = (): ReactElement => {
  const { t } = useTranslation()
  const { vatExemptionMentionModalForm } = useVatExemptionMentionModalForm()
  const { FormItem, watch } = vatExemptionMentionModalForm

  const vatExemptionMentionScheme = watch('vatExemptionScheme')
  const mentionLength = vatExemptionMentionScheme.length

  return (
    <FormItem
      name="vatExemptionScheme"
      label={
        <Flex justifyContent="space-between" alignItems="center">
          <Text variant="bodyMD" weight="medium">
            {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.body.mention_field.title')}
          </Text>
        </Flex>
      }
      render={({ field }) => (
        <Flex flexDirection="column" gap={Spacing.S8}>
          <Textarea
            {...field}
            resizable
            rows={TEXT_AREA_ROWS_COUNT}
            maxLength={MAX_VAT_EXEMPTION_MENTION_LENGTH}
            size="sm"
            placeholder={t(
              'settings.organization.external_invoice.general.vat_exemption_mention.modal.body.mention_field.placeholder',
            )}
          />
          <Flex justifyContent="space-between" gap={Spacing.S16}>
            <Text variant="bodySM" colorVariant="discreet">
              {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.body.mention_field.note')}
            </Text>

            <Text variant="bodySM" color={Color.Grey800}>
              {mentionLength}/{MAX_VAT_EXEMPTION_MENTION_LENGTH}
            </Text>
          </Flex>
        </Flex>
      )}
    />
  )
}
